module.exports = __webpack_public_path__ + "static/media/solidity-basics.6b863f1b.jpg";